var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet2 = function SvgWallet2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M3.25.125A3.14 3.14 0 0 0 .125 3.25v13.542c0 1.15.932 2.083 2.083 2.083h14.584a2.083 2.083 0 0 0 2.083-2.083V6.375a2.083 2.083 0 0 0-2.083-2.083H3.25A1.025 1.025 0 0 1 2.208 3.25c0-.589.453-1.042 1.042-1.042h13.542a1.041 1.041 0 1 0 0-2.083zm12.5 10.417a1.042 1.042 0 1 1 0 2.084 1.042 1.042 0 0 1 0-2.084"
  })));
};
export { SvgWallet2 as ReactComponent };